const productsForSearchReducer = (state = [], action) => {
  switch (action.type) {
    case "SET_PRODUCTS_SEARCH":
      return action.payload;
    default:
      return state;
  }
};

export default productsForSearchReducer;
